'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var axios = require('axios');
var qs = require('qs');

var _require = require('./entity/entityProvider'),
    EntityProvider = _require.EntityProvider;

var _headers = function _headers(token) {
  return {
    'Content-Type': 'application/json;charset=UTF-8',
    'x-auth-token': token
  };
};

module.exports.genericSearchTemplate = function (connection) {
  return function (Entity, searchMethod) {
    return function (params) {
      return axios.get(connection.getURIPrefix() + '/api/' + Entity.__name__() + '/search/' + searchMethod, {
        params: params,
        headers: _headers(connection.getToken()),
        paramsSerializer: function paramsSerializer(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' });
        }
      }).then(function (response) {
        // due to a Spring bug in dealing with ordered references, the rel attribute had to
        // be overwritten, so trying to find an `abstractPerson` yields a list of `person`
        var rel = typeof Entity.__rel__ === 'function' ? Entity.__rel__() : Entity.__name__();
        var resdata = response.data._embedded ? response.data._embedded[rel] : [];
        return {
          data: resdata,
          meta: response.data.page
        };
      }).then(function (_ref) {
        var data = _ref.data,
            meta = _ref.meta;

        if (Array.isArray(data)) {
          return {
            // Minor TODO: use the passed Entity as fallback?
            // data: data.map(x => new Entity(x)),
            data: data.map(function (x) {
              return new (EntityProvider(x._entityName))(x);
            }),
            meta: meta
          };
        } else {
          // Minor TODO: use the passed Entity as fallback?
          // return new Entity(data)
          return new (EntityProvider(data._entityName))(data);
        }
      });
      // Error should be handled by client (to give user feedback)
      // .catch(error => console.log(error))
    };
  };
};

module.exports.searchTemplate = function (connection) {
  return function (entity, searchMethod, parameterName) {
    return function (value, additionalParams) {
      var params = void 0;
      if (value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
        params = value;
      } else {
        params = additionalParams || {};
        params[parameterName] = value;
      }
      return module.exports.genericSearchTemplate(connection)(entity, searchMethod)(params);
    };
  };
};

module.exports.genericSaveTemplate = function (connection) {
  return function (route) {
    return function (data) {
      if (data._id) {
        var _id = data._id;
        return axios({
          method: 'put',
          headers: _headers(connection.getToken()),
          url: connection.getURIPrefix() + '/api/' + route + '/' + _id,
          data: data
        });
      } else {
        throw Error('No ID in data!');
      }
    };
  };
};

module.exports.genericCreateTemplate = function (connection) {
  return function (route) {
    return function (data) {
      return axios({
        method: 'post',
        headers: _headers(connection.getToken()),
        url: connection.getURIPrefix() + '/api/' + route + '/',
        data: data
      });
    };
  };
};

module.exports.genericGetTemplate = function (connection) {
  return function (entity) {
    return function (_id) {
      return axios({
        method: 'get',
        headers: _headers(connection.getToken()),
        url: connection.getURIPrefix() + '/api/' + entity + '/' + _id
      });
    };
  };
};

module.exports.genericDeleteTemplate = function (connection) {
  return function (entity) {
    return function (_id) {
      return axios({
        method: 'delete',
        headers: _headers(connection.getToken()),
        url: connection.getURIPrefix() + '/api/' + entity + '/' + _id
      });
    };
  };
};

module.exports.genericResolveRefsTemplate = function (connection) {
  return function (entity) {
    return function (ref) {
      return function (_id) {
        return axios({
          method: 'get',
          headers: _headers(connection.getToken()),
          url: connection.getURIPrefix() + '/api/' + entity + '/' + _id + '/' + ref
        });
      };
    };
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/templates.js
// module id = YzSa
// module chunks = 0